// useDateCrsConverter.js
import { useRef, useCallback } from 'react';
import debounce from 'lodash/debounce';
import dayjs from 'dayjs';
import { getDtToCr, getCrToDt } from '../utils/api';
import { debounceInterval } from '../utils/globals';
import { setAndUpdate } from '../utils/helpers'; // assuming this is defined somewhere

export const useDatetimeCarringtonConverter = (setter, update) => {
  // Create a debounced function that does the conversion.
  const convertDatesAndCrs = useRef(
    debounce((k, v, crSetter = null, d2r = false) => {
      if (d2r) {
        if (v) {
          getDtToCr({ dt: v })
            .then(response => {
              crSetter(response.data.toFixed(2));
            })
            .catch(err => {
              console.error(err);
              crSetter('');
            });
        } else {
          crSetter('');
        }
      } else {
        if (v) {
          getCrToDt({ cr: v })
            .then(response => {
              // setAndUpdate is a helper that calls setter and update.
              setAndUpdate(k, dayjs(response.data).format("YYYY-MM-DD HH:mm:ss"), setter, update);
            })
            .catch(err => {
              console.error(err);
              setAndUpdate(k, '', setter, update);
            });
        } else {
          setAndUpdate(k, '', setter, update);
        }
      }
    }, debounceInterval)
  ).current;

  // Function to handle dt -> CR conversion
  const dtToCR = useCallback((k, v, crSetter, plot = true) => {
    // Save the original value.
    setter(k, v);
    // Convert dt to CR.
    convertDatesAndCrs(k, v, crSetter, true);
    if (plot) {
      update(k, v);
    }
  }, [setter, update, convertDatesAndCrs]);

  // Function to handle CR -> dt conversion
  const crToDT = useCallback((k, v, crSetter) => {
    // Immediately update the cr field.
    crSetter(v);
    // Then convert CR to dt.
    convertDatesAndCrs(k, v, crSetter, false);
  }, [convertDatesAndCrs]);

  return { dtToCR, crToDT };
};
